// Frontend mirror of backend/auth_roles.py. UI hiding only — the backend is the
// real security boundary (it 403s/scopes regardless of what the UI shows).
//
// Roles: owner, admin, manager, member (legacy, full ops), installer, commercial.

export const FINANCE_ROLES = new Set(["owner", "admin", "manager", "member"]);

export const roleOf = (role) => role || "member";
export const isFinanceRole = (role) => FINANCE_ROLES.has(roleOf(role));
export const isInstaller = (role) => roleOf(role) === "installer";
export const isCommercial = (role) => roleOf(role) === "commercial";
export const isRestricted = (role) => isInstaller(role) || isCommercial(role);

// installer -> assigned works/agenda only; commercial -> clients/quotes.
// /ayuda is harmless support content and stays available to every role.
export const INSTALLER_ROUTES = new Set(["/projects", "/agenda", "/ayuda"]);
export const COMMERCIAL_ROUTES = new Set(["/clients", "/quotes", "/templates", "/ayuda"]);

// Routes a role is allowed to see in the sidebar. null => no restriction.
export const allowedRoutesFor = (role) => {
  if (isInstaller(role)) return INSTALLER_ROUTES;
  if (isCommercial(role)) return COMMERCIAL_ROUTES;
  return null;
};

export const isRouteAllowedFor = (role, pathname = "") => {
  const allowed = allowedRoutesFor(role);
  if (!allowed) return true;
  const cleanPath = (pathname || "").split("?")[0].split("#")[0] || "/";
  return Array.from(allowed).some((route) => cleanPath === route || cleanPath.startsWith(`${route}/`));
};

// Landing route per role (dashboard is finance-only, so restricted roles go home).
export const homeRouteFor = (role) =>
  isInstaller(role) ? "/projects" : isCommercial(role) ? "/clients" : "/dashboard";
